import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-my-network',
  templateUrl: './my-network.component.html',
  styleUrl: './my-network.component.scss',
})
export class MyNetworkComponent implements AfterViewInit, OnDestroy {
  private network: any;
  private nodes: any;
  private edges: any;
  private visLoaded = false;
  public imageUrl = environment.ImageUrl

  constructor(private elementRef: ElementRef, private auth: AuthServiceService) {}

  ngAfterViewInit(): void {
    this.loadVisJs();
  }

  ngOnDestroy(): void {
    if (this.network) {
      this.network.destroy();
    }
  }

  private loadVisJs(): void {
    // Check if vis is already loaded
    if (typeof (window as any).vis !== 'undefined') {
      this.visLoaded = true;
      this.initNetwork();
      return;
    }

    // Load vis.js dynamically
    const script = document.createElement('script');
    script.src =
      'https://unpkg.com/vis-network/standalone/umd/vis-network.min.js';
    script.onload = () => {
      this.visLoaded = true;
      this.initNetwork();
    };
    script.onerror = () => {
      console.error('Failed to load Vis.js');
    };
    document.head.appendChild(script);
  }

  private initNetwork(): void {
    if (!this.visLoaded) return;

    const vis = (window as any).vis;






    // this.nodes = new vis.DataSet([
    //   {
    //     id: 1,
    //     label: 'Luna',
    //     shape: 'circularImage',
    //     image: 'https://randomuser.me/api/portraits/women/44.jpg',
    //     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
    //   },
    //   {
    //     id: 2,
    //     label: 'Maya',
    //     shape: 'circularImage',
    //     image: 'https://randomuser.me/api/portraits/women/68.jpg',
    //     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
    //   },
    //   {
    //     id: 3,
    //     label: 'Verosica',
    //     shape: 'circularImage',
    //     image: 'https://randomuser.me/api/portraits/men/22.jpg',
    //     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
    //   },
    //   {
    //     id: 4,
    //     label: 'Darklord',
    //     shape: 'circularImage',
    //     image: 'https://randomuser.me/api/portraits/men/74.jpg',
    //     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
    //   },
    //   {
    //     id: 5,
    //     label: 'Alice',
    //     shape: 'circularImage',
    //     image: 'https://randomuser.me/api/portraits/women/12.jpg',
    //     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
    //   },
    //   {
    //     id: 6,
    //     label: 'John',
    //     shape: 'circularImage',
    //     image: 'https://randomuser.me/api/portraits/men/13.jpg',
    //     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
    //   },
    //   {
    //     id: 7,
    //     label: 'Sarah',
    //     shape: 'circularImage',
    //     image: 'https://randomuser.me/api/portraits/women/23.jpg',
    //     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
    //   },
    //   {
    //     id: 8,
    //     label: 'Mike',
    //     shape: 'circularImage',
    //     image: 'https://randomuser.me/api/portraits/men/32.jpg',
    //     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
    //   },
    // ]);

    // // Edges (light green initially)
    // this.edges = new vis.DataSet([
    //   {
    //     id: '1-2',
    //     from: 1,
    //     to: 2,
    //     color: { color: 'rgba(0,255,0,0.3)' },
    //     width: 2,
    //   },
    //   {
    //     id: '1-3',
    //     from: 1,
    //     to: 3,
    //     color: { color: 'rgba(0,255,0,0.3)' },
    //     width: 2,
    //   },
    //   {
    //     id: '1-4',
    //     from: 1,
    //     to: 4,
    //     color: { color: 'rgba(0,255,0,0.3)' },
    //     width: 2,
    //   },
    // ]);

this.auth.getSiteFollowData().subscribe({
  next: apiResponse =>{
    const users = apiResponse.body.users;
    const followData = apiResponse.body.followData;

    const nodes = users.map(user => {
      return {
        id: user.id,
        label: user.profileCharacterName,
        shape: 'circularImage',
        image: `${this.imageUrl}${user.profileCharacterImage}`,
        color: { border: 'rgba(0,255,0,0.6)', background: '#111' },

      }
    })
    this.nodes = new vis.DataSet(nodes);

    const edges = followData.map(
      follow =>{
        const from = follow.followerId
        const to = follow.followedId
        return {
          id: `edge-${from}-${to}`,
          from,
          to,
          color: { color: 'rgba(0,255,0,0.3)' },
          width: 2,
        }
      }
    )
    this.edges = new vis.DataSet(edges);
    const container = this.elementRef.nativeElement.querySelector('#mynetwork');
    const data = { nodes: this.nodes, edges: this.edges };

    const options = {
      nodes: {
        borderWidth: 4,
        size: 40,
        font: { color: '#fff', size: 14 },
        shadow: {
          enabled: true,
          color: 'rgba(0,0,0,0.6)',
          size: 15,
          x: 5,
          y: 5,
        },
      },
      edges: {
        smooth: { type: 'dynamic' },
        shadow: true,
      },
      physics: {
        enabled: true,
        stabilization: false,
        barnesHut: { gravitationalConstant: -20000 },
      },
    };

    this.network = new vis.Network(container, data, options);
    this.setupEventHandlers();


  }
})

// Create 20 nodes
// let nodesArray: any[] = [];
// for (let i = 1; i <= 20; i++) {
//   nodesArray.push({
//     id: i,
//     label: `User ${i}`,
//     shape: 'circularImage',
//     image: `https://randomuser.me/api/portraits/${i % 2 === 0 ? 'men' : 'women'}/${i}.jpg`,
//     color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
//   });
// }
//this.nodes = new vis.DataSet(nodesArray);

// Create edges (connect each node to a few others)
// let edgesArray: any[] = [];
// for (let i = 1; i <= 20; i++) {
//   let target1 = Math.floor(Math.random() * 20) + 1;
//   let target2 = Math.floor(Math.random() * 20) + 1;

//   if (target1 !== i) {
//     edgesArray.push({
//       id: `${i}-${target1}`,
//       from: i,
//       to: target1,
//       color: { color: 'rgba(0,255,0,0.3)' },
//       width: 2,
//     });
//   }

//   if (target2 !== i && target2 !== target1) {
//     edgesArray.push({
//       id: `${i}-${target2}`,
//       from: i,
//       to: target2,
//       color: { color: 'rgba(0,255,0,0.3)' },
//       width: 2,
//     });
//   }
// }
// this.edges = new vis.DataSet(edgesArray);




    // const container = this.elementRef.nativeElement.querySelector('#mynetwork');
    // const data = { nodes: this.nodes, edges: this.edges };

    // const options = {
    //   nodes: {
    //     borderWidth: 4,
    //     size: 40,
    //     font: { color: '#fff', size: 14 },
    //     shadow: {
    //       enabled: true,
    //       color: 'rgba(0,0,0,0.6)',
    //       size: 15,
    //       x: 5,
    //       y: 5,
    //     },
    //   },
    //   edges: {
    //     smooth: { type: 'dynamic' },
    //     shadow: true,
    //   },
    //   physics: {
    //     enabled: true,
    //     stabilization: false,
    //     barnesHut: { gravitationalConstant: -20000 },
    //   },
    // };

    // this.network = new vis.Network(container, data, options);
    // this.setupEventHandlers();
  }

  private setupEventHandlers(): void {
    if (!this.network) return;

    this.network.on('click', (params: any) => {
      // Reset all nodes to green border
      this.nodes.forEach((node: any) => {
        this.nodes.update({
          id: node.id,
          color: { border: 'rgba(0,255,0,0.6)', background: '#111' },
        });
      });

      // Reset all edges to green opacity
      this.edges.forEach((edge: any) => {
        this.edges.update({
          id: edge.id,
          color: { color: 'rgba(0,255,0,0.3)' },
        });
      });

      // If clicked a node
      if (params.nodes.length > 0) {
        const nodeId = params.nodes[0];

        // Change clicked node border to yellow
        this.nodes.update({
          id: nodeId,
          color: { border: 'yellow', background: '#111' },
        });

        // Change connected edges to gray
        const connectedEdges = this.network.getConnectedEdges(nodeId);
        connectedEdges.forEach((edgeId: string) => {
          this.edges.update({
            id: edgeId,
            color: { color: 'gray' },
          });
        });

        // Zoom to node
        const nodePosition = this.network.getPositions([nodeId]);
        this.network.moveTo({
          position: nodePosition[nodeId],
          scale: 2,
          animation: { duration: 500, easingFunction: 'easeInOutQuad' },
        });
      }
    });
  }
}
